const T_PREFIX = "header";

export const menuTrns = {
  clones: `${T_PREFIX}.menu.clones`,
  inquiries: `${T_PREFIX}.menu.inquiries`,
  opportunities: `${T_PREFIX}.menu.opportunities`,
  aboutUs: `${T_PREFIX}.menu.about-us`,
  contactUs: `${T_PREFIX}.menu.contact-us`,
  blog: `${T_PREFIX}.menu.blog`,
};

export const authButtonsTrns = {
  loginButton: `${T_PREFIX}.auth-buttons.login-btn`,
  signUpButton: `${T_PREFIX}.auth-buttons.sign-up-btn`,
};

export const profileTrns = {
  altUserName: `${T_PREFIX}.profile.alt-user-name`,
};
